module.exports = __webpack_public_path__ + "static/media/search_icon3_yl.74998fb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search_icon3_yl.svg
// module id = 254
// module chunks = 0